export const config = _sys => {
  return {
    defaultModuleApi: 'home-api'
  };
};